module.exports = __webpack_public_path__ + "static/media/9@3x.1a5a3e80.png";